import '../styles.scss';
import React from 'react';
import Chart from 'react-apexcharts';
import SemDados from '../SemDados';

const RegionalSolicitacao = (props) => {
  const { data } = props;

  const titulo = 'SOLICITAÇÕES POR REGIONAL';

  if (!data || Object.keys(data).length === 0)
    return <SemDados titulo={titulo} />;

  const regioes = Object.keys(data);

  const series = [{ data: regioes.map((regiao) => data[regiao].quantidade) }];

  const options = {
    colors: ['#021f59'],
    plotOptions: {
      bar: {
        horizontal: true,
        dataLabels: {
          position: 'top',
          hideOverflowingLabels: true,
          orientation: 'horizontal',
        },
      },
    },
    xaxis: {
      max: Math.max(...regioes.map((regiao) => data[regiao].quantidade)) * 1.55,
      labels: {
        show: false,
        style: {
          fontWeight: 900,
        },
      },
      categories: regioes.map((regiao) => regiao.toUpperCase()),

      axisTicks: {
        show: false,
      },
    },
    yaxis: {
      show: true,
      labels: {
        show: true,
        style: {
          fontSize: '12px',
          fontWeight: 'bold',
        },
      },
    },
    grid: {
      show: false,
      row: {
        colors: ['#dcdcdc', 'transparent'],
        opacity: 0.5,
      },
      padding: {
        top: -10,
        bottom: -15,
      },
      xaxis: {
        lines: {
          show: false,
        },
      },
    },
    chart: {
      height: 'auto',
      id: 'reg-solicitacoes',
      parentHeightOffset: 0,
      toolbar: {
        show: true,
      },
    },
    dataLabels: {
      textAnchor: 'start',
      offsetX: 5,
      offsetY: 6,
      formatter: (value, { dataPointIndex }) => {
        return `${parseInt(value, 10).toLocaleString('pt-BR')} (${
          data[regioes[dataPointIndex]].percentual
        }%)`;
      },
      style: {
        fontSize: '0.75rem',
        fontWeight: 'light',
        colors: ['#373d3f'],
      },
    },
    tooltip: {
      followCursor: true,
      intersect: false,
      onDatasetHover: {
        highlightDataSeries: false,
      },
      // eslint-disable-next-line
      custom: ({ series, seriesIndex, dataPointIndex }) => {
        return `<div class="arrow_box">
            <span>
              Regional: <span id="data">${regioes[
                dataPointIndex
              ].toUpperCase()}</span>
            </span>
            <span>
              Total de Solicitação: <span id="data">${parseInt(
                series[seriesIndex][dataPointIndex],
                10
              ).toLocaleString('pt-BR')}</span>
            </span>
            <span>
              % Aprovados: <span id="data">${
                data[regioes[dataPointIndex]].percentual
              }%</span>
            </span>
          </div>
          `;
      },
    },
  };

  return (
    <div className="grafico">
      <div className="grafico-titulo">
        <span>{titulo}</span>
      </div>
      <Chart options={options} series={series} type="bar" height="300" />
    </div>
  );
};

export default RegionalSolicitacao;
